var e=function(){var e={accept:"application/json","content-type":"application/json"};return"1"===new URLSearchParams(window.location.search).get("purge")&&(e["x-ov-purge"]="1"),{method:"POST",headers:e}};export{e as fetchOptions};
//# sourceMappingURL=api.mjs.map
